import { render, staticRenderFns } from "./EventPublishDialog.vue?vue&type=template&id=e3bf38be&"
import script from "./EventPublishDialog.vue?vue&type=script&lang=js&"
export * from "./EventPublishDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports